const activityRouter = {
  path: '/activity',
  redirect: '/activity/hot',
  component: () => import('@/layout/orderHeader'),
  children: [
    {
      path: '/activity/hot',
      name: 'Faddish',
      meta: { title: '市场热卖' },
      component: () => import(/* webpackChunkName: "activity" */ '@/pages/activies/hot')
    },
    {
      path: '/activity/hot/:id(\\d+)',
      name: 'Faddish',
      meta: { title: '市场热卖' },
      component: () => import(/* webpackChunkName: "activity" */ '@/pages/activies/hot')
    }
  ]
}

export default activityRouter
